// extracted by mini-css-extract-plugin
export var button__primary = "styles-module--button__primary--117e5";
export var closeButton = "styles-module--close-button--45511";
export var confettiLink = "styles-module--confetti-link--dee8b";
export var cursor = "styles-module--cursor--c5545";
export var cursorFollower = "styles-module--cursor-follower--d0e54";
export var headingCentered = "styles-module--heading-centered--1c84d";
export var imageIcon = "styles-module--image-icon--5ab64";
export var noScroll = "styles-module--no-scroll--ed7c9";
export var overlay = "styles-module--overlay--b4666";
export var overlayContainer = "styles-module--overlay-container--efc81";
export var pageTemplatePageGame = "styles-module--page-template-page-game--67743";
export var primaryConfettiColor = "#4babb1";
export var root = "styles-module--root--e075c";
export var secondaryConfettiColor = "#000";
export var section__wrapper = "styles-module--section__wrapper--1e74a";
export var section__wrapperLarge = "styles-module--section__wrapper--large--fcd61";
export var show = "styles-module--show--f568e";
export var tertiaryConfettiColor = "#fff";